import * as contentful from 'contentful';

const CONTENTFUL_SPACE_ID = 'cwukhln8eedp';
const CONTENTFUL_DELIVERY_TOKEN = '5LWSH-RwKToNCG7Z7m9IMMvh-0y23A0INgbZDuIgsr0';
// const CONTENTFUL_PREVIEW_TOKEN = 'ycQxHz1aitxsolZxY0nLa4EfsEOYa3Zo6QB1SiBtOFg';
const CONTENTFUL_PRODUCTION_ENVIRONMENT_ID = 'master';
const CONTENTFUL_STAGING_ENVIRONMENT_ID = 'staging';

const spaceId = CONTENTFUL_SPACE_ID;
const deliveryToken = CONTENTFUL_DELIVERY_TOKEN;
const productionEnvironmentId = CONTENTFUL_PRODUCTION_ENVIRONMENT_ID;
const stagingEnvironmentId = CONTENTFUL_STAGING_ENVIRONMENT_ID;

if (!spaceId || !deliveryToken || !productionEnvironmentId) {
  console.error(
    'Contentful credentials are not fully configured in src/api/Contentfull.ts!',
  );
}

let deliveryClient: contentful.ContentfulClientApi<undefined> | null = null;

if (spaceId && deliveryToken) {
  try {
    deliveryClient = contentful.createClient({
      space: spaceId,
      accessToken: deliveryToken,
      environment: productionEnvironmentId,
      // host: 'cdn.contentful.com', // Default
    });
  } catch (error: unknown) {
    const err = error as Error;
    console.error('Error creating Contentful Delivery Client:', err);
  }
}

let stagingClient: contentful.ContentfulClientApi<undefined> | null = null;

if (spaceId && deliveryToken) {
  try {
    stagingClient = contentful.createClient({
      space: spaceId,
      accessToken: deliveryToken,
      environment: stagingEnvironmentId,
      // host: previewHost,
    });
  } catch (error: unknown) {
    const err = error as Error;
    console.error('Error creating Contentful Staging Client:', err);
  }
}

export const getDeliveryClient = () => {
  if (!deliveryClient) {
    console.warn(
      'Contentful Delivery Client not initialized. Check configuration in src/api/Contentfull.ts.',
    );
  }
  return deliveryClient;
};

export const getStagingClient = () => {
  if (!stagingClient) {
    console.warn(
      'Contentful Staging Client not initialized. Check configuration in src/api/Contentfull.ts.',
    );
  }
  return stagingClient;
};
